import { Component } from '@theme/component';

/**
 * Product tabs: activates the first tab on connect, and switches tabs on click.
 * Markup: blocks/product-tabs.liquid + blocks/_tab.liquid.
 *
 * @extends {Component}
 */
class ProductTabs extends Component {
  connectedCallback() {
    super.connectedCallback();
    if (!this.querySelector('[aria-selected="true"]')) {
      this.#activateFirst();
    }
  }

  /**
   * Re-select a tab after the Section Rendering API morphs this block (e.g. the merchant
   * reordered or added a tab in the editor) if the previously active tab no longer exists.
   */
  updatedCallback() {
    if (!this.querySelector('[aria-selected="true"]')) {
      this.#activateFirst();
    }
  }

  #activateFirst() {
    const firstTab = this.querySelector('.product-tabs__tab');
    if (firstTab instanceof HTMLElement) this.#activate(firstTab);
  }

  /**
   * @param {Event} event
   */
  selectTab = (event) => {
    const button = event.target instanceof Element ? event.target.closest('.product-tabs__tab') : null;
    if (button instanceof HTMLElement) this.#activate(button);
  };

  /**
   * @param {HTMLElement} button
   */
  #activate(button) {
    const panelId = button.getAttribute('aria-controls');

    this.querySelectorAll('.product-tabs__tab').forEach((tab) => {
      tab.setAttribute('aria-selected', String(tab === button));
    });

    this.querySelectorAll('.product-tabs__panel').forEach((panel) => {
      panel.hidden = panel.id !== panelId;
    });
  }
}

if (!customElements.get('product-tabs-component')) {
  customElements.define('product-tabs-component', ProductTabs);
}
